module.exports = __webpack_public_path__ + "img/main-gallery3.a47df1f2.webp";